import React, { useEffect,  useState } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { resetQualityWise, QualityWise1 } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";


export default function QualityWise({ selectedProduction, selectedAccount }) {


  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { QualityWisedata } = useSelector((state) => state.GreyDashboardSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  useEffect(() => {
    dispatch(resetQualityWise())
    dispatch(QualityWise1({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])


  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    QualityWisedata?.OpInwMeter?.[0]?.FAcYear
  );

  const tableData = (QualityWisedata?.OpInwMeter || []).map(
    (row, index, arr) => ({
      // srNumber: (index + 1),
      ItemName: row.ItemName,
      OpInwMeter: row.OpInwMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];

  const getYearFromRange = (range) => {
    if (!range) return "";

    const parts = range.split("-");

    if (parts.length === 2) {
      const startYear = parts[0].split("/").pop();
      const endYear = parts[1].split("/").pop().slice(-2);
      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const uniqueYears = [
    ...new Set(
      (QualityWisedata?.OpInwMeterMonth || []).map((el) =>
        getYearFromRange(el.AcYear)
      )
    ),
  ];

  const groupedData = {};

  (QualityWisedata?.OpInwMeterMonth || []).forEach((row) => {
    const group = row.ItemName;
    const year = getYearFromRange(row.AcYear);

    if (!groupedData[group]) {
      groupedData[group] = {
        ItemName: group,
        TotalOpInwMeter: 0, // 👈 total initialize
      };
    }

    groupedData[group][year] = row.OpInwMeter;

    // 👇 total add karte jao
    groupedData[group].TotalOpInwMeter += row.OpInwMeter || 0;
  });

  const tableData1 = Object.values(groupedData).map((item, index) => ({
    // srNumber: index + 1,
    ...item,
  }));

  const columns1 = [
    { label: "Charts", key: "charts" },
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },

    // 👇 Total Meter column
    {
      label: "Total Meter",
      key: "TotalOpInwMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },

    // 👇 Dynamic Year Columns
    ...uniqueYears.map((year) => ({
      label: year,
      key: year,
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    })),
  ];

  const isNoData =
    !QualityWisedata?.OpInwMeter ||
    QualityWisedata?.OpInwMeter.length === 0;

  if (QualityWisedata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }



  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row className="justify-content-center" style={{ margin: 0, padding: 0 }}>

        <Col md={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{

                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"
                }}
              >

                QUALITYWISE DATA

              </h2>
              <p
                className="text-sm mt-1 mb-0"

              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>
        <Col md={12} className="pt-4" style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,

                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{
                  // color: "rgb(255, 255, 255)",
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"
                }}
              >
                YEARWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"

              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}